import script from "./NetherlandsGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./NetherlandsGuide.vue?vue&type=script&lang=ts&setup=true"

import "./NetherlandsGuide.vue?vue&type=style&index=0&id=cf4766b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf4766b4"]])

export default __exports__